<template>
    <div class="bg-white px-md-5 py-3">
        <h4 v-if="isEditing" class="edit-step-title">Contenido del curso</h4>
        <h3 v-if="!isEditing" class="step-title">Carga de contenido</h3>
        <p v-if="!isEditing" class="step-description">Una sección es un bloque de información que contiene lecciones... lo ideal es que una sección contenga diferentes medios de aprendizaje como textos, videos, imagenes y presentaciones. Una sección es un tema? La lección es un subtema?</p>

        <div class="row mt-5">
            <div class="col-md-12">
                <button class="btn bg-utel ms-auto d-block text-white rounded-8" @click="addModule">
                    <i class="fa fa-plus"></i>
                    <span>Agregar módulo</span>
                </button>

                <div class="mt-3">
                    <v-expansion-panels variant="accordion">
                        <v-expansion-panel class="panel" v-for="(item, index) in step2Data.modules" :key="'module-'+ item.id + index">
                            <v-expansion-panel-header class="panel-header d-flex justify-content-between align-items-center" >
                                <span class="text-start">{{ item.name || ('Módulo ' + (index + 1)) }}</span>
                                <template v-slot:actions="{ expanded: moduleExpanded }">
                                    <i class="text-end fa" :class="moduleExpanded ? 'fa-angle-up' : 'fa-angle-down'"></i>
                                </template>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content class="panel-content">
                                <create-course-step-2-module
                                    :module="item"
                                    :editing="isEditing"
                                    :eliminaPost="eliminaPost"
                                    :eliminaItemLesson="eliminaItem"
                                    :eliminaSection="eliminaSection"
                                    @onDelete="deleteModule"
                                ></create-course-step-2-module>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </div>
            </div>
        </div>

        <div class="row mt-5">
            <div class="col-md-12">
                <button class="btn bg-utel ms-auto d-block text-white rounded-8" @click="addQuestionnaire">
                    <i class="fa fa-plus"></i>
                    <span>Agregar cuestionario</span>
                </button>

                <div class="mt-3">
                    <v-expansion-panels variant="accordion">
                        <v-expansion-panel class="panel" v-for="(item, index) in step2Data.questionnaires" :key="'cuestionario-'+item.id+index">
                            <v-expansion-panel-header class="panel-header d-flex justify-content-between align-items-center" >
                                <span class="text-start">Cuestionario {{ index + 1 }}</span>
                                <template v-slot:actions="{ expanded: questionnaireExpanded }">
                                    <i class="text-end fa" :class="questionnaireExpanded ? 'fa-angle-up' : 'fa-angle-down'"></i>
                                </template>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content class="panel-content">
                                <create-course-step-2-questionnaire
                                    :questionnaire="item"
                                    :editing="isEditing"
                                    :eliminaPost="eliminaPost"
                                    :eliminaQuizQuestion="eliminaQuizQuestion"
                                    :eliminaQuestionAnswer="eliminaQuestionAnswer"
                                    :eliminaSection="eliminaSection"
                                    :eliminaItemQuestionnaire="eliminaItem"
                                    @onDelete="deleteQuestionnaire"
                                ></create-course-step-2-questionnaire>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </div>
            </div>
        </div>

        <div v-if="!isEditing" class="d-flex flex-wrap flex-column gap-2 flex-md-row gap-md-0 mt-5 justify-content-between">
            <button class="btn mx-3 mx-md-0 btn-outline-primary rounded-8 px-5" @click="goBack">
                Regresar
            </button>
            <button :disabled="!isStepValid" @click="saveCourse('draft')" class="custombutton btn mx-3 mx-md-0 btn-outline-primary rounded-8 px-5">
                Guardar borrador
            </button>
            <button :disabled="!isStepValid" @click="saveCourse()" class="custombutton btn mx-3 mx-md-0 btn-primary text-light rounded-8 px-5">
                Guardar curso
            </button>
        </div>
    </div>
</template>
<script>
    export default {
        props: [
            'stepData',
            'editing',
            'eliminaPost',
            'eliminaSection',
            'eliminaItem',
            'eliminaQuizQuestion',
            'eliminaQuestionAnswer'
        ],
        data(){
            return {
                step2Data: this.stepData || {
                    modules: [
                        {
                            id: Date.now(),
                            name: '',
                            description: '',
                            lessons: [],
                            isValid: false
                        }
                    ],
                    questionnaires: [
                        {
                            id: Date.now(),
                            aprobacion: "",
                            repeticiones: "",
                            duracion: "",
                            tipoDuracion: "",
                            questions: [],
                            isValid: false
                        }
                    ]
                },
                isEditing: this.editing || false
            }
        },
        computed: {
            isStepValid(){
                return this.validateStep();
            }
        },
        methods: {
            addModule(){
                this.step2Data.modules.push({
                    id: Date.now(),
                    name: '',
                    description: '',
                    lessons: [],
                    isValid: false
                })
            },
            addQuestionnaire(){
                this.step2Data.questionnaires.push({
                    id: Date.now(),
                    aprobacion: "",
                    repeticiones: "",
                    duracion: "",
                    tipoDuracion: "",
                    questions: [],
                    isValid: false
                });
            },
            goBack(){
                this.$emit('onBack', this.step2Data);
            },
            saveCourse(type = 'publish'){
                if (!this.validateStep()) return;

                this.$emit('onSave', {
                    ...this.step2Data,
                    courseState: type
                });
            },
            validateStep(){
                const invalidModules = this.step2Data.modules.filter(module => module.isValid === false);
                const invalidQuestionnaires = this.step2Data.questionnaires.filter(questionnaire => questionnaire.isValid === false);
                return invalidModules.length === 0 && invalidQuestionnaires.length === 0;
            },
            deleteModule(module){
                if (!module?.id) return;

                this.step2Data.modules = this.step2Data.modules.filter(m => m.id !== module.id);
            },
            deleteQuestionnaire(questionnaire){
                if (!questionnaire.id) return;

                this.step2Data.questionnaires = this.step2Data.questionnaires.filter(q => q.id !== questionnaire.id);
            }
        }
    }
</script>
<style>
    .panel::before{
        box-shadow: none !important;
    }

    .panel-header{
        background-color: #CBB9FF;
        color: #000;
    }

    .panel-content{
        border: 1px solid #CBB9FF;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
    }

    .step-title{
        color: #494949;
        font-size: 700;
        font-size: 25px;
    }

    .step-description{
        color: #494949;
        font-size: 16px;
    }

    .custombutton:disabled{
        background-color: #BCB7D1 !important;
        color: #6B6876 !important;
        border: none !important;
    }

    .edit-step-title{
        color: #424148;
        font-size: 20px;
        font-weight: 700;
    }
</style>
